import { render } from "./AppSubmenu.vue?vue&type=template&id=ee88e37a"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\PHPRad Projects\\uplbmv2\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__